import {
  CaseDetailsActionTypes,
  CASE_DETAILS_FAIL,
  CASE_DETAILS_LOADING,
  CASE_DETAILS_SUCCESS,
  CaseDetailsState,
  CASE_DETAILS_API_MSG,
  CASE_DETAILS_API_RES,
} from "./ActionTypes";
import { PatientCaseDetailsResponse } from "./Model";

const initialStateEditPosts: CaseDetailsState = {
  loading: false,
  caseDetailsResponse: {} as PatientCaseDetailsResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const caseDetailsReducer = (
  state = initialStateEditPosts,
  action: CaseDetailsActionTypes
): CaseDetailsState => {
  switch (action.type) {
    case CASE_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CASE_DETAILS_SUCCESS:
      return {
        ...state,
        caseDetailsResponse: action.payload,
        successMsg: action.successMsg,
      };
    case CASE_DETAILS_FAIL:
      return {
        ...state,
        caseDetailsResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CASE_DETAILS_API_MSG:
      return {
        ...state,
        caseDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CASE_DETAILS_API_RES:
      return {
        ...state,
        caseDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
